import React from "react";

const IconPrinter = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_printer_light"
      data-name="UI icon/printer/light"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Union"
        d="M12,20H8a3,3,0,0,1-3-3H3a3,3,0,0,1-3-3V8A3,3,0,0,1,3,5H5V3A3,3,0,0,1,8,0h4a3,3,0,0,1,3,3V5h2a3,3,0,0,1,3,3v6a3,3,0,0,1-3,3H15A3,3,0,0,1,12,20ZM7,14v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V14ZM5,12H15a1,1,0,0,1,0,2v1h2a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1H3A1,1,0,0,0,2,8v6a1,1,0,0,0,1,1H5V14a1,1,0,1,1,0-2ZM8,2A1,1,0,0,0,7,3V5h6V3a1,1,0,0,0-1-1Z"
        transform="translate(2 2)"
        fill={color}
      />
      <path
        id="Ellipse_16_Stroke_"
        data-name="Ellipse 16 (Stroke)"
        d="M1,2A1,1,0,1,0,0,1,1,1,0,0,0,1,2Z"
        transform="translate(17 10)"
        fill={color}
      />
    </svg>
  );
};

export default IconPrinter;
